var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-all-clear-all"},[_c('button',{staticClass:"fa fa-long-arrow-right",class:{
      disabled: !_vm.activeFields.length,
      delayed: _vm.lastHover === 'addAll'
    },on:{"mouseover":function($event){return _vm.addDelay('addAll')},"click":_vm.clearFields}}),_vm._v(" "),_c('button',{staticClass:"fa fa-long-arrow-left",class:{
      disabled: !_vm.remainingFields.length,
      delayed: _vm.lastHover === 'clearFields'
    },on:{"mouseover":function($event){return _vm.addDelay('clearFields')},"click":_vm.addAllFields}})])}
var staticRenderFns = []

export { render, staticRenderFns }